import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import lotteryspinner from "@/assets/lotteryspinner.svg";
import RecentActivities from "@/features/Dashboard/components/recentActivities";
import Logo from "@/assets/tableLogo.svg";
import readme from "@/assets/readme.svg";
import { theme } from "@/components/Elements/theme";
import { useLocation, useNavigate } from "react-router-dom";
import UpcomingLotteryCrousel from "@/features/Homescreen/Components/upcomingLotteryCrousel";
import UpComingLotteryDraws from "@/features/Homescreen/Components/upcomingLotteryDraws";
import WinningHistory from "@/features/Homescreen/Components/winningHistory";
import { useLotteries } from "../api/getDashboardList";
import Countdown from "react-countdown";
import { any } from "zod";
import Timer from "./Timer";
import TableDynamic from "./TableDynamic";
import HomeScreenImg from "@/assets/earth.jpg";
import yellowt from "@/assets/yellow-t.png";
import whitet from "@/assets/white-t.png";
import { axios } from "@/lib/axios";
import { useRecentActivities } from "../api/getRecentActivity";

const useStyles = makeStyles((_theme) => ({
  myGridItem: {
    backgroundColor: "rgb(75 75 75 / 80%)",
    [theme.breakpoints.down("md")]: {
      padding: "15px 10px",
    },
    [theme.breakpoints.up("md")]: {
      padding: "30px",
    },
    borderRadius: "20px",
  },
  innerGrid: {
    backgroundColor: "#050518",
    padding: "10px 15px",
    borderRadius: "20px",
    height: "100%",
    boxSizing: "border-box",
  },
  innerGridFirst: {
    background: `url(${lotteryspinner})`,
    backgroundRepeat: "no-repeat",
    height: "auto",
    width: "auto",
    minHeight: "282px",
    minWidth: "282px",
    backgroundPosition: "left bottom",
    [theme.breakpoints.down("sm")]: {
      minHeight: "200px",
      minWidth: "200px",
    },
  },
  innerGridSecond: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
  },
  tableContainer: {
    background: "#050518",
    borderRadius: 8,
  },
  table: {
    minWidth: 650,
  },
  tableHeader: {
    color: "#fff",
  },
  tableData: {
    fontSize: "14px",
    color: "#fff",
    opacity: "0.6",
    borderBottom: "1px solid #0D0D39",
  },
  logo: {
    width: 50,
  },
}));

const rows = [
  {
    id: 1,
    jackpot: "First Draw Prize",
    amount: "$100,000",
  },
  {
    id: 2,
    jackpot: "2nd Draw Prize",
    amount: "$75,000",
  },
  {
    id: 3,
    jackpot: "3rd Draw Prize",
    amount: "$45,000",
  },
  {
    id: 4,
    jackpot: "4th Draw Prize",
    amount: "$30,000",
  },
];

export const DashboardMain = () => {
  const location = useLocation();
  const classes = useStyles();
  const LotteryQuery = useLotteries({});
  const { data: recentActivities, refetch } = useRecentActivities({});

  useEffect(() => {
    if (location.state?.refresh) {
      console.log("Refreshing lotteries due to navigation state");
      LotteryQuery.refetch();
      refetch();
    }
  }, [location.state]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  console.log(recentActivities, "recentActivities");

  const upcomingArray = LotteryQuery?.data;

  if (LotteryQuery.status === "success") {
    let arr1 = LotteryQuery?.data;
  }

  // ("upCommingLotteries");
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();

  // if (LotteryQuery.isLoading) {
  //   return (
  //     <>
  //       <CircularProgress />
  //     </>
  //   );
  // }

  return (
    <>
      <Box
        sx={{
          background: `linear-gradient(89.41deg, #1B1C2D 7.81%, rgba(27, 28, 45, 0) 38.09%), linear-gradient(1.53deg, #1B1C2D 13.32%, rgba(27, 28, 45, 0) 50.41%), linear-gradient(46.49deg, #1B1C2D 14.7%, rgba(27, 28, 45, 0) 43.39%), url(${HomeScreenImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          padding: {
            xs: "10px 0",
            lg: "100px 0px 20px",
          },
          height: "100%",
          minHeight: "calc(100vh - 415px)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "768px",
            margin: "0 auto",
            textAlign: "center",
            fontFamily: '"Ubuntu", sans-serif',
            fontSize: "25px",
            lineHeight: "1.5",
          }}
        >
          <Typography
            component="h4"
            sx={{
              textTransform: "capitalize",
              fontWeight: "500 !important",
              marginBottom: { xs: "10px", md: "15px" },
              fontSize: { xs: "18px", md: "20px", lg: "24px" },
            }}
          >
            Dashboard
          </Typography>
        </Box>
        <Box
          sx={{
            maxWidth: "95%",
            margin: "0 auto",
            [theme.breakpoints.down("md")]: {},
          }}
        >
          <Box className={classes.myGridItem}>
            <Grid
              sx={{ width: "100%", mx: "auto" }}
              container
              spacing={{ xs: 2, md: 2, lg: 3 }}
              justifyContent="space-around"
            >
              <Grid item xs={12} sm={6}>
                <Box className={classes.innerGrid}>
                  <Grid container sx={{ height: "100%" }}>
                    <Timer dataRecent={LotteryQuery?.data} />
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  className={classes.innerGrid}
                  style={{ height: "100%", boxSizing: "border-box" }}
                >
                  <TableDynamic dataRecent={LotteryQuery?.data} />
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Grid container>
            <Grid item xs={12}>
              <Box>
                <RecentActivities dataRecent={recentActivities} />
              </Box>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Box>
                <UpcomingLotteryCrousel dataRecent={LotteryQuery?.data} />
              </Box>
            </Grid>
          </Grid>
          {/* <Grid container><Grid item xs={12}><Box><UpComingLotteryDraws  dataRecent={LotteryQuery?.data} /></Box></Grid></Grid> */}
          <Grid container>
            <Grid item xs={12}>
              <Box>
                <WinningHistory />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default DashboardMain;
